import Portal from './Portal.vue'
import PortalTarget from './PortalTarget.vue'

export default {
  install (app) {
    app.component('portal', Portal)
    app.component('portal-target', PortalTarget)
  }
}
